import React, { HTMLProps } from 'react';
import './DefTable.scss';

export type DefTableProps = HTMLProps<HTMLDListElement> & {
    children?: React.ReactNode;
};

export class DefTable extends React.Component<DefTableProps> {
    render() {
        const { className = '', children, ...props } = this.props;
        return (
            <dl className={'defTable ' + className} {...props}>
                {this.props.children}
            </dl>
        );
    }
}

type DefProps = {
    name: string;
    valueClassName?: string;
    className?: string;
    children?: React.ReactNode;
};

export class Def extends React.Component<DefProps & HTMLProps<HTMLElement>> {
    render() {
        const { valueClassName = '', className = '', name, children } = this.props;
        return (
            <div className={'defItem ' + className}>
                <div className="defName">{name}</div>
                <div className={'defValue ' + valueClassName}>{children}</div>
            </div>
        );
    }
}
